import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MoveBusinessServices } from './move-business.service';

@Injectable()
export class AdminAndPortalListResolver {
  constructor(private backend: MoveBusinessServices) {}
  resolve(): Observable<any[]> {
    return this.backend.getAdminUsersAndPortalTitles();
  }
}
